// extracted by mini-css-extract-plugin
export default {"video":"VideoEmbed_video__6HPu6","video__inner":"VideoEmbed_video__inner__tR1Yf","video__embed":"VideoEmbed_video__embed__AGfCF"};